export default __webpack_public_path__ + "static/media/Proxima Nova Alt Bold.da0d3d7c.otf";